import Vue from 'vue'

export const messageBusTopics = {
  SERVER_ERROR: 'SERVER_ERROR'
}

export const messageBus = new Vue(
  {
    methods: {
      serverError (error) {
        /* If the error contains childErrors in it's JSOn then extract the first childError message
           and lookup it's i18n, passing in the errorData as p0,p1 etc.
           If the above cannot be done then display the message for SERVER_ERROR */
        let message = ''
        if (error.response && error.response.data.childErrors && error.response.data.childErrors.length > 0) {
          let firstError = error.response.data.childErrors[0]
          let templateKey = firstError.errorType
          let data = {}
          if (firstError.errorData) {
            firstError.errorData.forEach((value, index) => {
              data['p' + index] = value
            })
          }
          message = this.$t(templateKey, data)
          if (templateKey === message) { // No i18n text, use server text
            message = firstError.errorDetail
          }
        } else {
          message = this.$t('SERVER_ERROR')
        }
        messageBus.$emit(messageBusTopics.SERVER_ERROR, message)
      }
    }
  }
)



// WEBPACK FOOTER //
// ./src/MessageBus.js